import JForm from './form'

export default JForm



// WEBPACK FOOTER //
// ./src/components/form/index.js